export default __webpack_public_path__ + "static/media/zarasa.33fc0b08.mp3";